import {metadaApi} from '@dms/api/base';

import {
  GetWorkshopOverviewApiArg,
  GetWorkshopOverviewApiResponse,
  GetWorkshopOverviewApiResponseSchema,
} from './types';

export const metadaWorkshopOverviewApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getWorkshopOverview: build.query<GetWorkshopOverviewApiResponse, GetWorkshopOverviewApiArg>({
      query: () => ({
        url: '/service/v1/workshop-overview',
      }),
      extraOptions: {
        responseSchema: GetWorkshopOverviewApiResponseSchema,
      },
    }),
  }),
});

export const {useGetWorkshopOverviewQuery} = metadaWorkshopOverviewApi;
